import { render, staticRenderFns } from "./WonderAiReportDetail.vue?vue&type=template&id=0c615e46&scoped=true"
import script from "./WonderAiReportDetail.vue?vue&type=script&lang=js"
export * from "./WonderAiReportDetail.vue?vue&type=script&lang=js"
import style0 from "./WonderAiReportDetail.vue?vue&type=style&index=0&id=0c615e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c615e46",
  null
  
)

export default component.exports